/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Icon from "./Icon";
import { Dropdown, Tooltip } from "react-bootstrap";
import Tick from "./Tick";
import { qreq } from "../shared/qrequest";
import L from "./Lang";
import Globals from "../shared/Globals";
import Auth from "../shared/Auth";
import Tutorial from "../shared/Tutorial";

class CartIcon extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            showTutorial: false,
            showDropdown: false
        };
    }

    componentDidMount() {
        this.tick();
        Tutorial.checkCompleted('cart-icon', b => {
            this.setState({ showTutorial: !b, });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const cart = Globals.get('cart');
        if (cart && (this.state.cart?.length !== cart.length || this.state.cart?.totalQuantity !== cart.totalQuantity)) {
            this.setState({ cart: cart });
        }
    }

    componentWillUnmount() {
    }

    tick = async () => {
        if (!Auth.hasRole('consumer')) return; // block
        await this.getCart();
    }

    remove = async (i) => {
        try {
            let j = await qreq.postAsync('/api/cart/remove', i);
            if (j.item) {
                Globals.set('cart', j.item);
                this.setState({ cart: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    toggleDropdown = () => {
        this.setState({ showDropdown: this.state.showTutorial ? false : !this.state.showDropdown, showTutorial: false });
        if (this.state.showTutorial) Tutorial.complete('cart-icon');
    }

    render() {
        if (!Auth.hasRole('consumer')) return; // block

        return <>
            <Tick interval={3000} onTick={this.tick} />
            <Dropdown className="ms-2 no-arrow" style={{ zIndex: '9992' }} show={this.state.showTutorial || this.state.showDropdown} onToggle={this.toggleDropdown}>
                <Dropdown.Toggle className="d-flex align-items-center text-decoration-none dropdown-toggle" variant={this.state.cart?.products?.length !== 0 ? 'warning' : 'secondary'}>
                    <strong><Icon icon="faCartShopping" /></strong> {this.state.cart?.totalQuantity !== 0 && <span className="ms-1">{this.state.cart?.totalQuantity}</span>}
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu dropdown-menu-dark shadow">
                    {this.state.cart?.products?.map((i, idx) => <div key={idx} className="p-2 d-flex gap-1">
                        <div><img src={Globals.getStorageURL(i.imageIdent)} alt="" className="img-fluid" style={{ width: '50px' }} /></div>
                        <div style={{ width: '200px' }}>{i.productName} {i.quantity > 0 && <span>x {i.quantity}</span>}</div>
                        <div><Icon icon="faCancel" onClick={() => this.remove(i)} /></div>
                    </div>)}
                    {this.state.cart?.products?.length !== 0 && <><hr /><Dropdown.Item onClick={this.cartCheckout}><L>Go to Checkout</L></Dropdown.Item></>}
                    {this.state.cart?.products?.length === 0 && !this.state.showTutorial && <Dropdown.Item><L>There are no items in your cart.</L></Dropdown.Item>}
                    {this.state.showTutorial && <Dropdown.Item>
                        <div className="d-flex gap-1">
                            <div><Icon icon="faInfoCircle" /></div>
                            <strong className="d-block"><L>This is your shopping cart, items added to cart will appear here.</L></strong>
                            <div><Icon icon="faClose" /></div>
                        </div>
                    </Dropdown.Item>}
                </Dropdown.Menu>
            </Dropdown>

        </>;
    }
}

export default withParamsAndNavigate(CartIcon);